import { allCountries } from "country-telephone-data";

/**
 * Country codes for phone number input (dial code + country name).
 * Format: { value: dialCode (e.g. "91"), label: "+91 India" }
 */
// export const COUNTRY_CODES = [
//   { value: "93", label: "+93 Afghanistan", flag: "🇦🇫" },
//   { value: "355", label: "+355 Albania", flag: "🇦🇱" },
// ];

function getFlagEmoji(countryCode) {
  return countryCode
    .toUpperCase()
    .replace(/./g, char =>
      String.fromCodePoint(127397 + char.charCodeAt())
    );
}


export const COUNTRY_CODES = allCountries.map((country) => ({
  value: country.dialCode,
  label: `+${country.dialCode} ${country.name}`,
  flag: getFlagEmoji(country.iso2),
}));


export const USER_ROLES = [
    { value: 'admin', label: 'Admin' },
    { value: 'user', label: 'User' },
  ]
